import { AbstractHttpService, LoadingError, type RequestOptions } from "vue-utils"
import { HttpLoadingError } from "./HttpLoadingError"

export class HttpService extends AbstractHttpService {
	readonly urlPrefix: string

	constructor(urlPrefix: string) {
		super()

		if (urlPrefix.endsWith("/")) {
			urlPrefix = urlPrefix.substring(0, urlPrefix.length - 1)
		}
		if (!urlPrefix.startsWith("/")) {
			urlPrefix = `/${urlPrefix}`
		}
		this.urlPrefix = urlPrefix
	}

	override async fetch(request: RequestOptions): Promise<Response> {
		let url = this.getUrl(request.url)
		if (url.startsWith("/") && window.location.hostname === "localhost") {
			url = `http://localhost:5162${url}`
		}

		let result
		try {
			result = await fetch(url, request)
		} catch (e) {
			console.error(e)
			throw new LoadingError(
				"Network Error",
				"A network error occurred performing that action. Check your connectivity and try again"
			)
		}
		const statusCode = result.status
		if (result.ok && statusCode >= 200 && statusCode < 300) {
			return result
		} else if (statusCode >= 400 && statusCode < 600) {
			const message = await this.tryReadJsonMessage(result)
			throw new HttpLoadingError(result, message ?? undefined)
		} else {
			throw new HttpLoadingError(result, "An unexpected error occurred performing that action")
		}
	}

	protected getUrl(url: string) {
		if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("/")) {
			return url
		}
		return `${this.urlPrefix}/${url}`
	}

	private async tryReadJsonMessage(result: Response): Promise<string | null> {
		try {
			const json = (await result.json()) as { message?: string }
			return json.message ?? null
		} catch (e) {
			return null
		}
	}
}
